import { Issue } from '../models/issue';

/**
 * This class is encapsulating some methods for dealing with storypoints that are used
 * by multiple boards
 */
export class StoryPointHelper {
  constructor() { }

  public static getSumOfStorypoints(issues: Issue[], onlyCountDoneIssues = false): number {
    let storyPointsTotal = 0;
    issues?.forEach(issue => {
      const issueIsDone = (issue.status.statusCategory.key === 'done');
      if (!onlyCountDoneIssues || (onlyCountDoneIssues && issueIsDone)) {
        storyPointsTotal += (issue.storyPoints) ? issue.storyPoints : 0;
      }
    });
    return storyPointsTotal;
  }


}
